// Cumulative, sessionStorage-backed timer for the free-preview limits (map, photos).
// "Session" here means browser tab session — clearing storage or closing the browser
// resets it, by design (see 2026-08-06 subscriptions spec, accepted trade-off).

const keyFor = (key) => `nasca360_preview_${key}`;

export function startTimer(key) {
  const storageKey = keyFor(key);
  if (sessionStorage.getItem(storageKey)) return; // already running
  sessionStorage.setItem(storageKey, JSON.stringify({ startedAt: Date.now(), accumulated: 0 }));
}

export function pauseTimer(key) {
  const storageKey = keyFor(key);
  const raw = sessionStorage.getItem(storageKey);
  if (!raw) return;
  const state = JSON.parse(raw);
  if (state.startedAt === null) return;
  const elapsed = (Date.now() - state.startedAt) / 1000;
  sessionStorage.setItem(storageKey, JSON.stringify({ startedAt: null, accumulated: state.accumulated + elapsed }));
}

export function resumeTimer(key) {
  const storageKey = keyFor(key);
  const raw = sessionStorage.getItem(storageKey);
  const state = raw ? JSON.parse(raw) : { accumulated: 0 };
  sessionStorage.setItem(storageKey, JSON.stringify({ startedAt: Date.now(), accumulated: state.accumulated }));
}

export function getElapsedSeconds(key) {
  const raw = sessionStorage.getItem(keyFor(key));
  if (!raw) return 0;
  const state = JSON.parse(raw);
  const running = state.startedAt !== null ? (Date.now() - state.startedAt) / 1000 : 0;
  return state.accumulated + running;
}

export function isExpired(key, limitSeconds) {
  return getElapsedSeconds(key) >= limitSeconds;
}
